import { blockName, initializeBlock } from "./../block";
import { initializeFrontendBlocks } from "../../blocks";

initializeFrontendBlocks(blockName, initializeBlock);
